import { render } from "./main-layout.vue?vue&type=template&id=34690d1e"
import script from "./main-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./main-layout.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/main-layout/main-layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34690d1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34690d1e', __exports__)) {
    api.reload('34690d1e', __exports__)
  }
  
  module.hot.accept("./main-layout.vue?vue&type=template&id=34690d1e", () => {
    api.rerender('34690d1e', render)
  })

}


export default __exports__